import expertGroundedAiBadgeUrl from '../../assets/expert-grounded-ai-badge.png';

export function ExpertGroundedAiPanel() {
  return (
    <aside aria-label="Expert-Grounded AI commitment" className="egai-commitment">
      <a
        aria-label="Visit Expert-Grounded AI (opens in a new tab)"
        href="https://www.egai.com.au/"
        rel="noreferrer noopener"
        target="_blank"
      >
        <img
          alt="Expert-Grounded AI badge"
          className="egai-commitment-badge"
          src={expertGroundedAiBadgeUrl}
        />
      </a>
      <p className="egai-commitment-copy">
        quality.vet is committed to implementing AI in ways that are responsible, transparent,
        evidence-informed and centred on quality educational and organisational outcomes.
      </p>
    </aside>
  );
}
